















































































































































































import Vue from "vue";
import store from "@/store";
import moment from "moment";

// Interface Imports
import {
  ChangeWorkoutHistory,
  WorkoutHistoryDateRanges,
} from "@/interfaces/history.interface";
import { WeightSet } from "@/interfaces/sets.interface";
import { Workout } from "@/interfaces/workout.interface";
import {
  secondsToTime,
  unixTimeToReadableDate,
} from "@/interfaces/time.interface";
import { getBestWeightedExerciseSet } from "@/interfaces/exercise.interface";

// Components
import Snackbar from "@/components/Snackbar.vue";
import { userData } from "@/interfaces/user.interface";
export default Vue.extend({
  data: () => {
    return {
      overlayLoader: false,

      videoDialog: false,
      videoUrl: "",

      areYouSureDialog: false,
      workoutToDelete: Object() as Workout,

      today: moment().format("MM-DD-YYYY"),
      lastMonth: moment()
        .subtract(1, "month")
        .format("MM-DD-YYYY"),

      workoutHistoryCards: Array<Workout>(),

      snackbar: false,
      snackbarText: "Workout Deleted",
    };
  },
  methods: {
    async onScroll() {
      if (
        window.innerHeight + window.pageYOffset >=
        document.body.offsetHeight
      ) {
        const currentDateRange: WorkoutHistoryDateRanges =
          store.getters["historyStore/getDateRange"];
        const newOld: number | null = currentDateRange.oldDate;
        const userData: userData | null =
          store.getters["userStore/getUserData"];

        if (newOld && userData) {
          if (newOld < userData.dateJoined) {
            alert("No workouts before this date");
          } else {
            this.overlayLoader = true;
            const newDateRange: WorkoutHistoryDateRanges = {
              recentDate: newOld,
              oldDate: newOld - 2629800,
            };
            await this.getWorkoutHistory(newDateRange).catch((err) => {
              console.error(err);
            });
            this.overlayLoader = false;
          }
        }
      }
    },
    async getWorkoutHistory(dateRange: WorkoutHistoryDateRanges) {
      await store
        .dispatch("historyStore/getWorkoutHistory", dateRange)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    toggleExtraDetailsForCard(workoutCardData: Workout) {
      let payload: ChangeWorkoutHistory = {
        startTime: workoutCardData.startTime,
        newHistoryCard: workoutCardData,
      };

      payload.newHistoryCard.showExtraDetails = !payload.newHistoryCard
        .showExtraDetails;

      store.commit("historyStore/changeHistoryWorkout", payload);
    },
    async openUpVideoDialog(videoUrl: string) {
      this.videoUrl = videoUrl;
      this.videoDialog = true;
    },
    getListOfBestSets(setList: WeightSet[]): string {
      return getBestWeightedExerciseSet(setList);
    },
    getFormattedSet(weight: number, reps: number): string {
      if (weight > 0) return `${weight} lbs x ${reps}`;
      else return `${reps} Reps`;
    },
    bringUpAreYouSureDialog(workout: Workout) {
      this.workoutToDelete = workout;
      this.areYouSureDialog = true;
    },
    unixTimeToReadableDate(timeStampUnix: number): string {
      return unixTimeToReadableDate(timeStampUnix);
    },
    async deleteWorkout() {
      this.areYouSureDialog = false;
      this.overlayLoader = true;

      await store
        .dispatch("workoutStore/deleteWorkout", this.workoutToDelete)
        .then((res) => {
          console.log(res);
          this.snackbar = true;
          this.snackbarText = "Workout was deleted ";
        })
        .catch((err) => {
          console.error(err);
          this.snackbar = true;
          this.snackbarText = "Workout could not be deleted ";
        });

      this.workoutToDelete = Object() as Workout;
      this.overlayLoader = false;
    },
    secondsToTime(seconds: number): string {
      return secondsToTime(seconds, true);
    },
    snackbarClose() {
      this.snackbar = false;
    },
  },
  computed: {
    workoutHistory(): Workout[] {
      return store.getters["historyStore/getWorkoutHistory"];
    },
  },
  components: {
    Snackbar,
  },
});
